import { Injectable } from '@angular/core';
import { EnvironmentService } from '@methylium/core';
import { HubService } from './hub.service';

@Injectable()
export class LocationsHubService extends HubService {
  constructor(environmentService: EnvironmentService) {
    super(`${environmentService.environment.locations.api as string}/hubs/locations`);
  }
}
